import React, { FC, useEffect, useState } from "react";
import { useWebgate } from "@xvia/webgate-connect";

import { CNH, getPaychecks, Paycheck } from "../../apis/user-related-services";

import {
  UserRelatedWidgets,
  UserRelatedWidgetsProps,
} from "./user-related-widgets";
import { DadosVeiculo } from "../../models/DadosVeiculoSimplesModel";
import { obterDadosVeiculos } from "../../apis/veiculo";

export const UserRelatedWidgetsContainer: FC = () => {
  const { accessToken, userInfo } = useWebgate();

  const [paychecks, setPaychecks] = useState<Paycheck[]>([]);
  const [vehicles, setVehicles] = useState<DadosVeiculo[]>([]);
  const [paychecksLoaded, setPaychecksLoaded] = useState(false);
  const [vehiclesLoaded, setVehiclesLoaded] = useState(false);

  const cnh = (userInfo?.cnh as CNH[]) ?? [];

  const userRelatedWidgetsProps: UserRelatedWidgetsProps = {
    paychecks,
    cnh,
    vehicles,
  };

  useEffect(() => {
    if (!accessToken) {
      setPaychecksLoaded(true);
      return;
    }
    const loadPaychecks = async () => {
      try {
        const result = await getPaychecks(accessToken);
        setPaychecks(result);
      } finally {
        setPaychecksLoaded(true);
      }
    };
    void loadPaychecks();
  }, [accessToken]);

  useEffect(() => {
    if (!accessToken) {
      setVehiclesLoaded(true);
      return;
    }
    const loadVehicles = async () => {
      try {
        const userVehicles = await obterDadosVeiculos(accessToken);
        setVehicles(userVehicles);
      } finally {
        setVehiclesLoaded(true);
      }
    };
    void loadVehicles();
  }, [accessToken]);

  if (!accessToken) {
    return null;
  }

  const widgetsReady = paychecksLoaded && vehiclesLoaded;
  if (!widgetsReady) {
    return null;
  }

  if (paychecks.length === 0 && cnh.length === 0 && vehicles.length === 0) {
    return null;
  }

  return <UserRelatedWidgets {...userRelatedWidgetsProps} />;
};
